import React from 'react';
import "./AboutPage.css";

export const AboutPage = () => (
  <div className="about-page">
  <div className="about-page-text-block">
  <br/>
  <div className="about-page-title">
  About NetworkBuddy
  </div><br/>
  We are a startup based on Melbourne Australia<br/><br/>
  Founded by <a href="https://www.linkedin.com/in/stephaniegaddin/" target="_blank" rel="noopener noreferrer">Stephanie Gaddin</a> and < a href="https://www.linkedin.com/in/trentin-barnard-5547281a/" target="_blank" rel="noopener noreferrer">Trentin Barnard</a><br/>
  Steph is the chick in charge, and Trentin is the main Tech Geek.<br/><br/>

  <div className="about-page-header">
  Where did the idea come from?
  </div>
  NetworkBuddy is about making networking easier for the shy and introverted,
  <br/> as well as maximizing reach when you’re first learning to network as a small business.
<br/><br/>
The concept evolved when Steph started mentoring a large number of startup founders <br/>
and small business solopreneurs in the art of business networking.
<br/><br/>
Almost everyone we speak to has similar stories of :
<br/><br/>
how terrifying their first business networking event was<br/>
how some felt excluded by a closed circle of people that clearly knew each other well<br/>
or they were simply not brave enough to start networking early enough to keep their business afloat.<br/>


<br/>
  <div className="about-page-header">
  Our core values
  </div>
  Our core values are connection, and collaboration , we believe very strongly in building up and helping our community.<br/>
<br/>
  <div className="about-page-header">
  How to participate
  </div>
  You can join the community and participate in a few different ways.<br/><br/>
<strong> Request a Buddy </strong>  - if you need that extra help, or mentoring: Find an event and hit the Request a Buddy Button. <br/>
<strong> Be a Buddy </strong>- List the events you are attending (via the FB group) and put yourself out there to buddy someone else<br/>
<strong> Event organisers</strong>- List your events with us for free (via FB group or email)- under the agreement that if someone requests a buddy for your event, you will be that buddy or arrange for a buddy appropriately.<br/>
  </div>
  <br />
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/AboutPage.js